/******************************************************************
 * @NAME ChenJi
 * @CREATEDATE 2020/11/17
 * @DESC <权限>
 * ****************************************************************/
import Vue from 'vue'
//设置按钮权限
function settingRoles(el, binding) {
  let obj = binding.value;
  // 用来调试用的
  // console.log(obj.role)
  // if(obj.role == 'M_DisableAndEnableIncidentAlarm'){
  //    debugger
  // }
  if (obj.menu) {
    let permissionCodes = obj.menu.permissionCodes || [];
    if (!permissionCodes.length) {
      return;
    }
    // 没有role或者roles为空数组，表示不做权限限制
    if (obj.role) {
      getRule(permissionCodes, obj.role, el);
    } else if (obj.roles && obj.roles.length > 0) {
      getRuleByRoles(permissionCodes, obj.roles, el);
    }
  }
}

function getRule(codes, role, el) {
  let flag = codes.findIndex(item => {
    return role === item;
  });
  if (flag === -1 || !codes.length) {
    if (el) {
      $(el).remove();
    }
  }
}

function getRuleByRoles(codes, roles, el) {
  let noCode = true;
  if (!codes.length) {
    noCode = true;
  } else {
    roles.forEach((role) => {
      let index = codes.findIndex(item => {
        return role === item;
      });
      if (index > -1) {
        noCode = false;
      }
    })
  }
  if (noCode) {
    if (el) {
      $(el).remove();
    }
  }
}

Vue.directive('role', {
  //当绑定元素插入到DOM中
  inserted: function (el, binding) {
    settingRoles(el, binding)
  },
  //当node发生变化时调用
  update: function (el, binding) {
    settingRoles(el, binding)
  },
});

function handleScrollDirective(el,binging){
  let timer = '';
  let lastSH = 0;
  let dom = el.querySelector('.ivu-select-dropdown');
  dom.onscroll = function(e){
    let target = e.target;
    clearTimeout(timer);
    timer = setTimeout(function(){
      queryData();
    },700);
    function queryData(){
      if (target.scrollTop === 0 || binging.arg.needResetScrollbarTop) { // 每次重新查询时,重置是否处理的开关
        lastSH = 0;
        if (binging.arg.needResetScrollbarTop) {
          binging.arg.needResetScrollbarTop = false;
        }
      }
      // 向下滚动
      // 过滤非用户滚动到底部触发的情况
      if (target.scrollHeight >= lastSH && target.scrollTop > 0 && target.scrollTop + 2 >= target.scrollHeight - target.clientHeight && (binging.arg.page || 1) < binging.arg.pageCount) {
        if (typeof binging.arg.page !== 'number') {
          binging.arg.page = 1;
        }
        lastSH = target.scrollHeight - 1;
        binging.arg.page++;
        binging.value(binging.arg);
      }
    }
  }
}
// 下拉框滚动加载
Vue.directive('scroll',{
  bind(el,binging){
    handleScrollDirective(el,binging);
  },
  update(el,binging){
    if (!binging.arg.hotUpdate) { // hotUpdate属性值为true才在每次更新dom时更新处理方法(避免深克隆对象导致bind没有更新binging.arg引起的问题)
      return;
    }
    handleScrollDirective(el,binging);
  }
});

Vue.directive('no-multiple-spaces', {
  bind(el) {
    el.addEventListener('input', function(event) {
      let value = event.target.value;
      value = value.replace(/^\s+/, '').replace(/\s+/g, ' ');
      event.target.value = value;
    });
    el.addEventListener('blur', function(event) {
      setTimeout(() => {
        let value = event.target.value;
        value = value.trim().replace(/\s+/g, ' ');
        event.target.value = value;
      }, 0);
    });
  }
});

export default {
  Vue
}



//////////////////
// WEBPACK FOOTER
// ./src/admin/directives/role.js
// module id = 0zN2
// module chunks = 15